var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animalBtn"},[_c('div',{staticClass:"cn nowrap"},[_vm._v(_vm._s(_vm.cnTitle))]),_c('div',{staticClass:"en nowrap",domProps:{"innerHTML":_vm._s(_vm.enTitle)}})])}
var staticRenderFns = []

export { render, staticRenderFns }